// Shared logout helper used by SideBar AND every profile page so the
// behavior stays consistent (verifier attendance closeout + activity
// flush + localStorage clear + redirect to /login).
import axios from "axios";
import { apiUrl } from "../config/config";

const isValidStored = (v) => {
  if (v === null || v === undefined) return null;
  const t = String(v).trim();
  if (!t || t === "null" || t === "undefined") return null;
  return t;
};

/**
 * Closes the current session.
 *  • Tells the backend the verifier logged out (writes LoggedoutTime
 *    on Verifier_Log) and flushes one final activity sample.
 *  • Clears localStorage.
 *  • Redirects to /login (unless `redirectUrl` overrides).
 *
 * Network failures are swallowed — the local logout always completes.
 *
 * Returns a promise that resolves once the backend hop has finished
 * (best-effort) so callers can await it before navigating.
 */
export async function performLogout(redirectUrl = "/login") {
  const verifierId = isValidStored(localStorage.getItem("verifierid"));
  const loginedTime = isValidStored(localStorage.getItem("loginedDateTime"));

  if (verifierId && loginedTime) {
    try {
      await axios.post(`${apiUrl}api/users/updateLogoutTime`, {
        Verifier_id: verifierId,
        LoginedTime: loginedTime,
      });
      const activityPct = Number(localStorage.getItem("activityPercentage"));
      const breakTime = Number(localStorage.getItem("breakTime"));
      await axios.post(`${apiUrl}api/users/UpdateVerifierActivity`, {
        Verifier_id: verifierId,
        LoginedTime: loginedTime,
        ActivityLevel: Number.isFinite(activityPct) ? Math.round(activityPct) : 0,
        BreaksConsumed: Number.isFinite(breakTime) ? Math.round(breakTime) : 0,
      });
    } catch (err) {
      // Surface only — never block the actual logout on a network blip.
      // eslint-disable-next-line no-console
      console.error("Logout API error:", err);
    }
  }

  localStorage.clear();
  window.location.href = redirectUrl;
}
